import React, { useEffect, useState } from 'react'

import {
	Dialog,
	DialogTitle,
	DialogContent,
	Typography,
	Checkbox,
	TextField,
	ListItemText,
	Button,
	DialogActions
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector, useDispatch } from 'react-redux'
import HouseholdAutocomplete from '../Autocompletes/Household'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { DeletableChip } from '../Misc/DeletableChip'
import { v4 as uuid } from 'uuid'
import { addCheckIn } from '../../actions/checkIns/checkins.actions'

const useStyles = makeStyles((theme) => ({
	close: {
		position: 'absolute',
		color: '#777679',
		top: 10,
		right: 10,
		padding: 10,
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 16,
		cursor: 'pointer'
	},
	dialog: {
		'& .MuiDialog-paper': {
			width: 920,
			maxWidth: 1000
		}
	},
	heading: {
		marginBottom: 16
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .MuiInputLabel-filled': {
			transform: 'translate(12px, 22px) scale(1)'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		},
		"& .MuiAutocomplete-inputRoot[class*='MuiFilledInput-root'][class*='MuiFilledInput-marginDense'] .MuiAutocomplete-input":
			{
				padding: '0px 4px 5px'
			}
	},
	dialogActions: {
		justifyContent: 'flex-start',
		padding: '16px 24px',
		borderTop: '1px solid #D0CFD2'
	},
	helperText: {
		fontFamily: 'Nunito',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '19px',
		color: '#777679',
		marginTop: 8
	},
	chip: {
		background: 'rgba(107, 74, 214, 0.1)',
		borderRadius: 6,
		padding: '3px 8px',
		'& > span': {
			fontFamily: 'Nunito',
			fontSize: '14px',
			fontWeight: 600,
			lineHeight: '19px',
			textTransform: 'none',
			color: '#5F38BE'
		},
		'& > div': {
			height: 14,
			fill: '#5F38BE'
		},
		'& .fas.fa-times': {
			'&::before': {
				color: '#5F38BE'
			},
			fontSize: '12px',
			fontWeight: 400,
			lineHeight: '12px'
		}
	}
}))

const AddCheckInDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const household = useSelector((state) => state.specific.households.selected)
	const facility = useSelector((state) => state.specific.facilities.selected)

	let initialCheckin = {
		household_id: null,
		initial_account_id: null,
		facility_id: null,
		pet_ids: [],
		guests: [],
		account_ids: []
	}

	const [checkIn, setCheckIn] = useState({ ...initialCheckin })

	let { isShown, setIsShown } = props

	useEffect(() => {
		if (!household) {
			setCheckIn(initialCheckin)
		}
	}, [household])

	const createCheckin = () => {
		let primary = household.accounts.find((a) => a.primary)
		let initial_account_id =
			primary && primary._id
				? primary._id
				: checkIn.account_ids && checkIn.account_ids.length
				? checkIn.account_ids[0]
				: null

		let check_in = {
			...checkIn,
			account_ids: [initial_account_id, ...checkIn.account_ids],
			household_id: household._id,
			facility_id: facility._id,
			guests: checkIn.guests.map((g) => ({ name: g.name })),
			initial_account_id
		}

		dispatch(addCheckIn(check_in))
		setIsShown(false)
	}

	useEffect(() => {
		return () => {
			dispatch({ type: 'GET_HOUSEHOLDS_SUCCESS', payload: [] })
			dispatch({ type: 'SET_SELECTED_HOUSEHOLD', payload: null })
		}
	}, [isShown])

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			disableBackdropClick
			onClose={() => {
				setIsShown(false)
			}}
			PaperProps={{
				style: {
					width: 920,
					maxWidth: 920,
					padding: 0
				}
			}}>
			<div style={{ width: '100%', borderBottom: '1px solid #D0CFD2' }}>
				<div style={{ padding: 24, paddingBottom: 16 }}>
					<DialogTitle style={{ marginBottom: 0 }}>ADD CHECK IN</DialogTitle>
					<span className={classes.close} onClick={() => setIsShown(false)}>
						X
					</span>
				</div>
			</div>
			<DialogContent style={{ padding: 24, width: '100%' }}>
				<div style={{ marginBottom: 32 }}>
					<Typography className={classes.heading} variant="h6">
						Primary Contact
					</Typography>
					<HouseholdAutocomplete />
				</div>
				<div>
					<Typography className={classes.heading} variant="h6">
						Visitors
					</Typography>
					<div style={{ marginBottom: 20 }}>
						<Autocomplete
							getOptionLabel={(option) => (option ? `${option.first_name} ${option.last_name}` : 'No Name')}
							disableCloseOnSelect
							multiple
							size="small"
							id="pets"
							disabled={!household}
							className={classes.autoComplete}
							options={household ? household.accounts.filter((a) => !a.primary) : []}
							value={
								household
									? checkIn.account_ids
											.map((id) => {
												let match = household.accounts.find((a) => a._id === id)

												return match
											})
											.filter((a) => !a.primary)
									: []
							}
							onChange={(e, v) =>
								setCheckIn({
									...checkIn,
									account_ids: v.map((a) => a._id)
								})
							}
							onClose={(e) => {
								e.target.value = ''
							}}
							renderTags={(selected) =>
								selected.map((v) => {
									return (
										<DeletableChip
											className={classes.chip}
											key={v._id}
											label={v.full_name ? v.full_name : `${v.first_name} ${v.last_name}`}
											onDelete={() =>
												setCheckIn({
													...checkIn,
													account_ids: checkIn.account_ids.filter((id) => id !== v._id)
												})
											}
										/>
									)
								})
							}
							renderOption={(option, { selected }) => (
								<React.Fragment>
									<Checkbox checked={selected} />
									<ListItemText primary={option ? `${option.first_name} ${option.last_name}` : ''} />
								</React.Fragment>
							)}
							renderInput={(params) => (
								<TextField {...params} variant="filled" label="Other Contacts" />
							)}
						/>
					</div>
					<div style={{ marginBottom: 20 }}>
						<Autocomplete
							getOptionLabel={(option) => (option ? option.name : 'No Name')}
							disableCloseOnSelect
							multiple
							size="small"
							id="contacts"
							disabled={!household}
							className={classes.autoComplete}
							options={
								household
									? household.pets.filter(
											(p) =>
												p.active && p.animal_type && p.animal_type.toLowerCase() === 'dog'
									  )
									: []
							}
							value={
								household
									? checkIn.pet_ids.map((id) => {
											let match = household.pets.find((p) => p._id === id)

											return match
									  })
									: []
							}
							onChange={(e, v) =>
								setCheckIn({
									...checkIn,
									pet_ids: v.map((p) => p._id)
								})
							}
							onClose={(e) => {
								e.target.value = ''
							}}
							renderTags={(selected) =>
								selected.map((v) => {
									return (
										<DeletableChip
											className={classes.chip}
											key={v._id}
											label={v.name}
											onDelete={() =>
												setCheckIn({
													...checkIn,
													pet_ids: checkIn.pet_ids.filter((id) => id !== v._id)
												})
											}
										/>
									)
								})
							}
							renderOption={(option, { selected }) => (
								<React.Fragment>
									<Checkbox checked={selected} />
									<ListItemText primary={option ? option.name : ''} />
								</React.Fragment>
							)}
							renderInput={(params) => <TextField {...params} variant="filled" label="Dogs" />}
						/>
					</div>
					{/*<div>
						<Autocomplete
							freeSolo
							multiple
							size="small"
							id="guests"
							getOptionLabel={(option) => (option ? option.name : 'No Name')}
							disabled={!household}
							className={classes.autoComplete}
							options={[]}
							value={checkIn.guests}
							onChange={(e, v) => {
								setCheckIn({
									...checkIn,
									guests: v.map((g) => {
										return g && g.id ? g : { id: uuid(), name: g }
									})
								})
							}}
							renderTags={(selected) =>
								selected.map((v) => {
									return (
										<DeletableChip
											className={classes.chip}
											key={v.id}
											label={v.name}
											onDelete={() =>
												setCheckIn({
													...checkIn,
													guests: checkIn.guests.filter((guest) => guest.id !== v.id)
												})
											}
										/>
									)
								})
							}
							renderOption={(option, { selected }) => (
								<React.Fragment>
									<Checkbox checked={selected} />
									<ListItemText primary={option ? option.name : ''} />
								</React.Fragment>
							)}
							renderInput={(params) => (
								<TextField
									{...params}
									variant="filled"
									label="Guests"
									onKeyDown={(e) => {
										if (
											(e.key === 'Enter' || e.key === 'Tab' || e.key === ',') &&
											e.target.value
										) {
											e.preventDefault()

											setCheckIn({
												...checkIn,
												guests: [...checkIn.guests, { id: uuid(), name: e.target.value }]
											})
										} else {
											return true
										}
									}}
								/>
							)}
						/>
						<Typography className={classes.helperText}>
							Hit tab, comma, or return to continue to add multiple items. Hit backspace/delete to
							remove an item.
						</Typography>
					</div>*/}
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					disabled={!household}
					onClick={() => createCheckin()}
					color="secondary">
					Create Record
				</Button>
				<Button variant="outlined" onClick={() => setIsShown(false)} color="secondary">
					Cancel
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default AddCheckInDialog
